import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 313918D8-1CB9-40FC-B24F-3A974F1A6EAF
 * name playlist-play
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/playlist-play.svg
 * tags
 */
export const PlaylistPlayIcon = createSvgIcon(<><path d="M3 10H14V12H3V10M3 6H14V8H3V6M3 14H10V16H3V14M16 13V21L22 17L16 13Z" /></>, 'PlaylistPlayIcon');
export default PlaylistPlayIcon